// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3YXiv","requiredAsterisk":"Info_requiredAsterisk__2W5uO"};